import { NavigationExtras } from '@angular/router';

export const GO = '[Router] Go';
export const BACK = '[Router] Back';
export const FORWARD = '[Router] Forward';

export function NavigateAction(payload: {
  path: any[];
  query?: object;
  extras?: NavigationExtras;
  reason?: String;
}) {
  return {
    type: GO,
    payload
  };
}
